import View from './view';
export const PrivilegeCard = View;
